import { typographyStyles, constants } from "@newsela/angelou";

const { textXSObj } = typographyStyles;
const { colors } = constants;

export const eyebrowCss = {
  ...textXSObj,
  fontWeight: 600,
  margin: 0,
  textTransform: "uppercase",
  color: colors.ui.neutral[700],
};
